import { render, staticRenderFns } from "./CatalogDataModal.vue?vue&type=template&id=21cab41c&"
import script from "./CatalogDataModal.vue?vue&type=script&lang=js&"
export * from "./CatalogDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports